var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C23.9556 0 27.8225 1.17298 31.1114 3.37061C34.4004 5.56823 36.9639 8.69181 38.4776 12.3463C39.9914 16.0009 40.3874 20.0222 39.6157 23.9018C38.844 27.7814 36.9392 31.3451 34.1422 34.1421C31.3451 36.9392 27.7814 38.844 23.9018 39.6157C20.0222 40.3874 16.0009 39.9913 12.3464 38.4776C8.69183 36.9638 5.56827 34.4004 3.37064 31.1114C1.17301 27.8224 0 23.9556 0 20C0 14.6957 2.10715 9.60859 5.85788 5.85786C9.6086 2.10714 14.6957 0 20 0V0ZM30.3273 22.7273V17.2727H22.7273V9.67273H17.2727V17.2727H9.67818V22.7273H17.2727V30.3218H22.7273V22.7273H30.3218H30.3273ZM20 5.45454C22.8739 5.45454 25.6834 6.30677 28.0729 7.90344C30.4625 9.50012 32.325 11.7695 33.4248 14.4247C34.5247 17.0799 34.8124 20.0016 34.2517 22.8203C33.691 25.639 32.3071 28.2282 30.2749 30.2604C28.2427 32.2925 25.6536 33.6765 22.8349 34.2372C20.0161 34.7978 17.0945 34.5101 14.4393 33.4103C11.7841 32.3104 9.51471 30.448 7.91803 28.0584C6.32136 25.6688 5.46914 22.8594 5.46914 19.9855C5.4701 16.1319 7.00131 12.4365 9.72617 9.71161C12.451 6.98675 16.1465 5.45551 20 5.45454Z",
    fill: "#32C832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistAdded);
export default __webpack_public_path__ + "static/media/playlist-added.685269b665171e0a8ec5bccbb7bcdf66.svg";
export { ForwardRef as ReactComponent };